import { Navigate, useLocation } from 'react-router-dom';
import currentSession            from 'utils/currentSession';
import PrivateLayout             from 'containers/PrivateLayout/PrivateLayout';

const PrivateRoute = () => {
  const location = useLocation();
  const isAuthenticated = currentSession.token !== '';

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <PrivateLayout />
  );
};

export default PrivateRoute;